import React, { useState } from 'react';
import './App.css';

import { GraphQLEditor } from 'graphql-editor';

const schemas = {
  pizza: `
type Query{
	pizzas: [String!]
}
`,
};

export const App = () => {
  const [mySchema, setMySchema] = useState({
    code: schemas.pizza,
  });

  return ( 
      <GraphQLEditor
        setSchema={(props) => {
          setMySchema(props);
        }}
        schema={mySchema}
      /> 
  );
};

export default App;
